import { type MenuGroup } from './MenuGroup.tsx';

export type MenuPresetsType = Record<string, MenuGroup[]>;

export const MenuPresets = {
  Minimal: ['default', 'disable-enter'], // TODO Rinominare in "InlineMinimal"
  // Come Minimal ma con il pulsante "Accapo" (etichette con layout a blocco)
  MinimalWithReturn: ['default', 'return', 'disable-enter'],
  Block: ['default', 'link', 'styles', 'align', 'list', 'return', 'color'],
  BlockWithoutTitle: ['default', 'list', 'link', 'color', 'return', 'align'],
  Inline: ['default', 'link', 'color', 'disable-enter'],
  InlineWithReturn: ['default', 'link', 'return', 'color', 'disable-enter'],
} satisfies MenuPresetsType;
